import type { SocketEventListener } from '@/shared/api';
import { EMITTER_CONSTANTS } from '@/shared/config';
import emitter from '@/shared/lib/eventEmitter';

const rmaRealtimeListeners: SocketEventListener[] = [
  {
    event: 'rmaTicketUpdated',
    handler: (msg: any) => {
      console.log('socket io - rmaTicketUpdatedListener', msg);
      emitter.emit(EMITTER_CONSTANTS.RMA_TICKET_UPDATED, msg);
    },
  },
  {
    event: 'rmaTicketCreated',
    handler: (msg: any) => {
      console.log('socket io - rmaTicketCreatedListener', msg);
      emitter.emit(EMITTER_CONSTANTS.RMA_TICKET_CREATED, msg);
    },
  },
];

export default rmaRealtimeListeners;
